import React from 'react'
import { cn } from './cn'

export interface InputAffixProps {
  prefix?: React.ReactNode
  suffix?: React.ReactNode
  children: React.ReactElement<{ className?: string }>
}

/**
 * Static unit/currency text (or a leading icon) that shares the input's outer
 * border and focus ring. Height and the field's type size read `--h-affix` /
 * `--fs-affix`: the web keeps the shared control height, the App surface uses the
 * 44px term box (kiao-tokens.css). Touch screens keep 16px so iOS Safari does not
 * zoom the page on focus, as `.input` already does. Both set the font size only:
 * a `text-*` utility would also set a line height the field never had.
 */
export function InputAffix({ prefix, suffix, children }: InputAffixProps) {
  return (
    <div className="flex h-[var(--h-affix)] items-center overflow-hidden rounded-[var(--radius)] border border-border bg-background focus-within:border-foreground focus-within:outline-2 focus-within:outline-[var(--focus-ring)]">
      {prefix ? (
        <span className="pointer-events-none shrink-0 select-none pl-3 text-sm text-muted">
          {prefix}
        </span>
      ) : null}
      {React.cloneElement(children, {
        className: cn(
          children.props.className,
          'min-w-0 flex-1 border-0 text-[length:var(--fs-affix)] focus:border-0 focus:outline-none pointer-coarse:text-[length:var(--text-lg)]'
        ),
      })}
      {suffix ? (
        <span className="pointer-events-none shrink-0 select-none pr-3 text-sm text-muted">
          {suffix}
        </span>
      ) : null}
    </div>
  )
}
